var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPersonFocus = function SvgPersonFocus(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-marketingfachleute") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#183E62",
    strokeWidth: 2,
    d: "M61.359 55c-.758.872-1.605 1.663-2.609 2.247v3.776c10.913 1.538 18.375 4.618 18.375 8.174 0 5.091-15.278 9.218-34.125 9.218S8.875 74.288 8.875 69.197c0-3.556 7.462-6.634 18.375-8.174v-3.776c-1.004-.584-1.85-1.375-2.609-2.247C10.658 57.565 1 62.95 1 69.197 1 77.925 19.805 85 43 85s42-7.075 42-15.803C85 62.949 75.342 57.565 61.359 55ZM42.5 22C48.3 22 53 17.3 53 11.5S48.3 1 42.5 1 32 5.7 32 11.5 36.7 22 42.5 22ZM32.167 53.947v15.79c0 2.906 2.313 5.263 5.166 5.263h10.334c2.853 0 5.166-2.357 5.166-5.263v-15.79c2.853 0 5.167-2.357 5.167-5.263v-15.79C58 28.535 54.53 25 50.25 25h-1.905c-1.788.827-3.756 1.316-5.845 1.316s-4.057-.489-5.845-1.316H34.75C30.47 25 27 28.535 27 32.895v15.79c0 2.905 2.314 5.262 5.167 5.262Z"
  })));
};
export default SvgPersonFocus;